import React from 'react';
import { Fab } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
const FloatingButton = React.memo((props) => {
    return (React.createElement(Fab, { mainButtonStyles: props.mainButtonStyles, icon: props.icon, text: "", event: 'click', alwaysShowTitle: false, onClick: props.onClick }));
});
export default FloatingButton;
